module["exports"] = [
  "沙市",
  "京市",
  "宁市",
  "安市",
  "乡县",
  "海市",
  "码市",
  "汉市",
  "阳市",
  "都市",
  "州市",
  "门市",
  "阳市",
  "口市",
  "原市",
  "南市",
  "徽市",
  "林市",
  "头市"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/zh_CN/address/city_suffix.js
// module id = 1348
// module chunks = 0